{
  "vendor": {
    "shell": {
      "supplying": "Supplying"
    },
    "ordersSearch": {
      "label": "Search by order number"
    },
    "respondHintAwaiting": "To confirm the order as sent, use “Confirm version {{version}}”. Choose an answer here only to give your own delivery date, report a shortfall, ask a question or decline.",
    "confirmNotesHint": "Optional — anything the buyer should know with your confirmation.",
    "answerNotesHint": "Optional — anything the buyer should know with this answer.",
    "chooseAnswer": "Choose an answer first.",
    "orderFilters": {
      "nextStep": "Needs you",
      "allSteps": "All next steps",
      "allResponses": "All answers",
      "noMatch": "No orders match these filters.",
      "steps": {
        "acknowledge": "Confirm the order",
        "dispatch": "Record dispatch",
        "invoice": "Send invoice",
        "with_buyer": "With the buyer",
        "nothing": "Nothing due"
      },
      "responses": {
        "pending": "No answer yet",
        "acknowledged": "Confirmed",
        "partially_available": "Partly available",
        "query": "Question",
        "declined": "Declined"
      }
    },
    "forms": {
      "required": "Complete this field.",
      "refused": "Your changes were not sent"
    },
    "versions": {
      "title": "Issued versions",
      "issued": "Issued {{date}}",
      "amended": "Amended {{date}}",
      "pending": "The document is being prepared.",
      "failed": "The document is not available. Contact the buyer."
    }
  },
  "vendorRfq": {
    "currentOffer": {
      "sentOn": "Sent {{date}}",
      "prices": "Your prices",
      "linePrice": "{{price}} per {{unit}}",
      "lineTotal": "Line total including tax: {{total}}",
      "terms": "Your terms",
      "subtotal": "Subtotal, excluding tax",
      "tax": "Tax",
      "total": "Total",
      "notGiven": "Not given",
      "startFrom": "Start from my current offer",
      "startFromHint": "Copies these prices and terms into the form above. Nothing is sent until you send a revised quote.",
      "copied": "Your current offer is copied into the form above. Change what you need, then send a revised quote.",
      "taxNotCopied": "The tax rate is not copied. Enter it again under Your offer.",
      "unchanged": "This is your current offer, unchanged. Change a price or a term to send a revision."
    },
    "listSearch": "Search by enquiry number or title",
    "listCapped": "Showing the first {{count}} enquiries. Search to find the others.",
    "notSent": "Your quote was not sent",
    "fieldErrors": {
      "taxRate": "Tax rate must be a number from 0 to 100.",
      "moq": "Minimum order quantity must be greater than 0.",
      "leadTime": "Lead time must be a whole number of days, from 0 to 3650.",
      "validUntil": "Price held until must be a valid date.",
      "unitPrice": "The price for {{item}} must be a number, 0 or more."
    }
  },
  "secureAction": {
    "answers": {
      "confirmNoDate": "Acknowledge the order as sent"
    },
    "rfqSignIn": "Sign in to the supplier portal"
  },
  "vendorAgreements": {
    "search": "Search by agreement title or reference"
  }
}
